<div
  appClickComponent
  [dataComponent]= component()
  appPosition [position]="
  {
    top: component().properties.position.y,
    left: component().properties.position.x
   }"
  [ngStyle]="{
        'fontSize.px': component().properties.fontSize,
        'color': component().properties.colorText,
        'width.px':component().properties.size.width,
        'height.px':component().properties.size.height,
        'border-radius.px':component().properties.cornerRadius
        }"
  class="flex w-full h-full"

>
  <img [src]="component().properties.base64Image??'img.png'"
       class="h-full w-full" alt="image">
</div>
